<template>
    <el-dialog title="编辑联系人" :visible.sync="vis">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="姓名" prop="contactWay.name" placeholder="必填" >
                <el-input v-model="contactWay.name" style="width: 300px" ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="contactWay.mobile" >
                <el-input v-model="contactWay.mobile" style="width: 300px" ></el-input>
            </el-form-item>
            <el-form-item label="区域" prop="contactWay.areaId" >
                <plt-address-cascader v-model="contactWay.areaId" width="300" />
            </el-form-item>
            <el-form-item label="详细地址" prop="contactWay.address" >
                <el-input type="textarea" v-model="contactWay.address" style="width: 300px" ></el-input>
            </el-form-item>
        </el-form>    
        <div slot="footer" class="dialog-footer">
            <el-button @click="vis = false">取消</el-button>
            <el-button type="primary" @click="submit">确定</el-button>
        </div>            
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            contactWay: {
                addressId: '',
                memberId: '',
                areaId: '',
                address: '',
                contactId: '',
                name: '',
                mobile: '',
                email: '',
                identityNo: ''
            },
            cwCopy: {},
            vis: false
        }
    },
    mounted() {
        this.cwCopy = {...this.contactWay};
    },
    methods: {
        openDialog(contactWay) {
            contactWay = {...contactWay};
            this.vis = true;
            if(!contactWay.addressId) {
                this.contactWay = {...this.cwCopy};
                this.contactWay.memberId = contactWay.memberId;
                return;
            }
            this.contactWay = contactWay;
        },
        submit() {
            this.notBlank(this.contactWay.name, "请输入联系人名称");
            
            let url = "CORE-MEMBER/messageService/memberCustomerService/editMemberContact";

            this.invoke(url, {contactWay: this.contactWay}).then(() => {
                this.vis = false;
                this.$emit('on-edit-success');
            })
        }
    }
}
</script>
